import {
  VoiceDetectorConstructor,
  VoiceDetector,
  VoiceDetectorOptions,
} from "@service/voice-detection/voice-detector";
import { MicVAD } from "@ricky0123/vad-web";

const VAD_ASSET_BASE = "/public/vad/";

/** Silero v5: 512 samples/frame at 16 kHz (see @ricky0123/vad-web) */
const V5_FRAME_SAMPLES = 512;
const V5_MS_PER_FRAME = (V5_FRAME_SAMPLES / 16_000) * 1000;
/** End-of-utterance hangover; matches @ricky0123/vad-web frame-processor default */
const DEFAULT_REDEMPTION_MS = 1400;

export const AiVoiceDetector: VoiceDetectorConstructor = class AiVoiceDetector
  implements VoiceDetector
{
  private vad: MicVAD | null = null;

  constructor(options: VoiceDetectorOptions) {
    void this.init(options);
  }

  async init({
    stream,
    callback,
    pauseDuration,
  }: VoiceDetectorOptions): Promise<void> {
    const redemptionMs = pauseDuration
      ? this.pauseDurationToRedemptionMs(pauseDuration)
      : DEFAULT_REDEMPTION_MS;

    this.vad = await MicVAD.new({
      model: "v5",
      baseAssetPath: VAD_ASSET_BASE,
      onnxWASMBasePath: VAD_ASSET_BASE,
      getStream: async () => stream,
      pauseStream: async () => {
        /* Stream is owned by the caller; only disconnect in MicVAD.pause */
      },
      resumeStream: async (s) => s,
      ortConfig: (ort) => {
        ort.env.wasm.numThreads = 1;
      },
      redemptionMs,
      onSpeechStart: () => {
        callback({ type: "start" });
      },
      onSpeechRealStart: () => {
        callback({ type: "real-start" });
      },
      onVADMisfire: () => {
        callback({ type: "misfire" });
      },
      onSpeechEnd: () => {
        callback({ type: "end" });
      },
      startOnLoad: true,
    });

    return;
  }

  destroy(): void {
    if (this.vad) {
      void this.vad.destroy().catch((e) => {
        console.error(e);
      });
    }
  }

  private pauseDurationToRedemptionMs(pauseDuration: number): number {
    const frames = Math.ceil(
      (pauseDuration * (16_000 / V5_FRAME_SAMPLES)) / 1000,
    );
    return frames * V5_MS_PER_FRAME;
  }
};
